import { render } from "./ContactsPeopleSummary.vue?vue&type=template&id=287e6ade"
import script from "./ContactsPeopleSummary.vue?vue&type=script&lang=js"
export * from "./ContactsPeopleSummary.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__